import React, {Component} from 'react';
import {useState} from 'react';
import ReactImageMagnify from 'react-image-magnify';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.css';

class ImageProduct extends Component {


    constructor(props) {
        super(props);
        this.state = {
            imgUrl: 'https://slonsneakers.ru/userfiles/shop/medium/10/98126_nike-air-jordan-4-retro.jpg',

            imgThumbnails: [
                {
                    firstThumbnail: 'https://slonsneakers.ru/userfiles/shop/medium/10/98126_nike-air-jordan-4-retro.jpg',
                    secondThumbnail: 'https://slonsneakers.ru/userfiles/shop/medium/10/98123_nike-air-jordan-4-retro.jpg',
                    thirdThumbnail: 'https://slonsneakers.ru/userfiles/shop/medium/10/98127_nike-air-jordan-4-retro.jpg',
                    fourthThumbnail: 'https://slonsneakers.ru/userfiles/shop/medium/10/98125_nike-air-jordan-4-retro.jpg',
                    fiveThumbnails: 'https://slonsneakers.ru/userfiles/shop/medium/10/98124_nike-air-jordan-4-retro.jpg'
                }
            ]
        }
    }

    render() {


        return (
            <div>
                <ReactImageMagnify className={"img-magnifier"} {...{
                    smallImage: {
                        alt: 'Wristwatch by Ted Baker London',
                        width: 600,
                        height: 500,
                        src: this.state.imgUrl
                    },
                    largeImage: {
                        src: this.state.imgUrl,
                        width: 1200,
                        height: 1800
                    }
                }} />
                <div className={"row row-thumbnails"}>
                    <div className={"col-auto col-thumbnails"} onClick={() => this.setState({imgUrl: this.state.imgThumbnails[0].firstThumbnail})}>
                        <img className={"img-thumbnail"} src={this.state.imgThumbnails[0].firstThumbnail}/>
                    </div>
                    <div className={"col-auto col-thumbnails"} onClick={() => this.setState({imgUrl: this.state.imgThumbnails[0].secondThumbnail})}>
                        <img className={"img-thumbnail"} src={this.state.imgThumbnails[0].secondThumbnail}/>
                    </div>
                    <div className={"col-auto col-thumbnails"} onClick={() => this.setState({imgUrl: this.state.imgThumbnails[0].thirdThumbnail})}>
                        <img className={"img-thumbnail"} src={this.state.imgThumbnails[0].thirdThumbnail}/>
                    </div>
                    <div className={"col-auto col-thumbnails"} onClick={() => this.setState({imgUrl: this.state.imgThumbnails[0].fourthThumbnail})}>
                        <img className={"img-thumbnail"} src={this.state.imgThumbnails[0].fourthThumbnail}/>
                    </div>
                    <div className={"col-auto col-thumbnails"} onClick={() => this.setState({imgUrl: this.state.imgThumbnails[0].fiveThumbnails})}>
                        <img className={"img-thumbnail"} src={this.state.imgThumbnails[0].fiveThumbnails}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImageProduct;